import { trackPromise } from "react-promise-tracker";

class WebServiceConsumer {
  constructor() {
    this._requests = [];
  }

  push(request) {
    this._requests.push(request);
  }

  consume(onRequestsFinish) {
    const promise = Promise.all(this._requests);

    if (onRequestsFinish) {
      promise.then(onRequestsFinish);
    }

    return trackPromise(promise);
  }
}

export default WebServiceConsumer;
